import { useAsyncCheckoutEnabled } from "@/components/Checkout/components/CheckoutV2/hooks/useAsyncCheckoutEnabled";
import React from "react";
import PurchaseListV1 from "../Purchase/purchaseList";
import PurchaseListV2 from "./purchaseList";
import PurchaseDetailV1 from "../Purchase/PurchaseDetail";
import PurchaseDetailV2 from "./PurchaseDetail";

export const PurchaseList = () => {
  const { enabled } = useAsyncCheckoutEnabled();
  if (enabled) {
    return <PurchaseListV2 />;
  }
  return <PurchaseListV1 />;
};

export const PurchaseDetail = () => {
  const { enabled } = useAsyncCheckoutEnabled();
  if (enabled) {
    return <PurchaseDetailV2 />;
  }
  return <PurchaseDetailV1 />;
};
